import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import { accountDiffRoutes, goToLive } from "./router";
import store from "./store";
import i18n from "./i18n";
import "./plugins/element.js";
import { defaultLocal } from "@/i18n";
import { getHourUtilTimestamp } from "@/utils";
import { setWebAppCacheData, getWebAppCacheData } from "@/utils/cache";
import "@gtt/webrtc-sdk/web-engine.min.js";
// main css
import "@/assets/css/index.css";
// 引入全局注册组件
import "@/components/globalComponents";
// global svg
import "@/icons/index.js";
// 全局引入自定义指令
import trim from "./directives/trim";
import scroll from "./directives/scroll";
Vue.directive("trim", trim);
Vue.directive("scroll", scroll);

// lazy load image
import VueLazyload from "vue-lazyload";
const loadImage =
  window.loadingVideoPic || require("./assets/imgs/loading.png");
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: loadImage,
  loading: loadImage,
  attempt: 1,
});
// google-adsense
import Ads from "vue-google-adsense";
// eslint-disable-next-line @typescript-eslint/no-var-requires
Vue.use(require("vue-script2"));
Vue.use(Ads.Adsense);
Vue.config.productionTip = false;
Vue.prototype._setWebAppCacheData = setWebAppCacheData;
Vue.prototype._getWebAppCacheData = getWebAppCacheData;
Vue.prototype._goToLive = goToLive;
Vue.prototype._getHourUtilTimestamp = getHourUtilTimestamp;

/**
 * 初始化前需要的必要资源
 */
import { IS_NOVA_TEMPLATE } from "./utils/cacheKey";
async function beforeEnter() {
  store.commit("set_active_language", defaultLocal);
  store.commit("set_langs", window.langs);
  const websiteName =
    (window as any)?.websiteNameI18nList?.find((el: any) => el.languageCode === defaultLocal)
      ?.value || (window as any).defaultWebsiteName;
  document.title = websiteName as string;
  // 注册 webRTC service worker
  window.p2pml.core.registerServiceWorker();
  // 获取当前使用的模板信息
  setWebAppCacheData(IS_NOVA_TEMPLATE, (window as any).templateTag === "classic" ? false : true);
  accountDiffRoutes();
}

// global filter
import "@/filters";

beforeEnter().then(() => {
  // 在创建 Vue 实例之前设置
  Vue.config.errorHandler = function (err, vm, info) {
    console.error("Vue 全局错误:", err, "信息:", info);
  };
  new Vue({
    router,
    store,
    i18n,
    render: (h: any) => h(App),
  }).$mount("#app");
});
